<template>
  <v-container
    id="renewalEdit"
    class="pa-0"
  >
    <v-row
      v-if="editedItem.manuallyAdded"
    >
      <v-col
        cols="6"
      >
        <div
          class="font-weight-bold green--text"
        >
          <v-icon
            color="green"
            medium
          >
            mdi-plus-circle-multiple
          </v-icon>
          New Plan
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Product"
          item-text="product"
          item-value="id"
          bind-text="product"
          bind-value="productId"
          :bind-item="editedItem"
          :error-messages="formErrors.ProductId"
          :resource="productResource"
          :fetch-method="getProducts"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Carrier"
          item-text="carrier"
          item-value="id"
          bind-text="carrier"
          bind-value="carrierId"
          :bind-item="editedItem"
          :error-messages="formErrors.CarrierId"
          :resource="carrierResource"
          :fetch-method="getCarriers"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="editedItem.change"
          section="OE Renewal - Change"
          :error-messages="formErrors.Change"
          :disabled="disabled"
          label="Carrier Change"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.rateChange"
          :error-messages="formErrors.RateChange"
          :disabled="disabled"
          label="Rate Change"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        &nbsp;
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.newPlanOffering"
          :error-messages="formErrors.NewPlanOffering"
          :disabled="disabled"
          label="New Plan Offering"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <!-- v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.newHireGIRules"
          :error-messages="formErrors.NewHireGIRules"
          :disabled="disabled"
          label="New Hire GI Rules"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.lateEntrantGIRules"
          :error-messages="formErrors.LateEntrantGIRules"
          :disabled="disabled"
          label="Late Entrant GI Rules"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.increasesToExistingGIRules"
          :error-messages="formErrors.IncreasesToExistingGIRules"
          :disabled="disabled"
          label="Increases To Existing GI Rules"
        />
      </v-col>
    </v-row -->
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'RenewalEdit',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      formErrors: {},
      editedItem: null,
      originalItem: null,

      productResource: new TroodyApi('product/'),
      carrierResource: new TroodyApi('carrier/'),
    }),

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.editedItem = this.value
        this.originalItem = Object.assign({}, this.value)
      },

      getProducts () {
        return this.productResource.getList()
      },

      getCarriers () {
        return this.carrierResource.getList()
      },

      transformItem () {
        this.editedItem.openEnrollmentId = this.openEnrollment.id
        this.editedItem.carrierChange = (this.originalItem.carrierId !== this.editedItem.carrierId)

        return this.editedItem
      },

      onChange () {
        this.transformItem()
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>

<style lang="sass">
.renewal-edit-label
  padding-top: 20px
</style>
